<a *ngIf="visible" class="nav-link" title="Ver Detalle" (click)="showDialog()" style="cursor: pointer;">
    <i class="fa fa-bell" aria-hidden="true" style="color: white !important;"></i>
    <p-progressSpinner class="spinnerAvisoInspector"></p-progressSpinner>
    <span class="badge badge-pill badge-warning">{{getRequestCount()}}</span>
</a>

<app-async-infopopup></app-async-infopopup>
